<template>
  <div id="graphic">
    <div class="graphic-card">
      <div class="graphic-title">
        <h3>{{configurations.title}}</h3>
        <h6>{{configurations.year}}</h6>
      </div>
      <canvas :id="configurations.idCont"></canvas>
    </div>
  </div>
</template>

<script>
import Bar from "vue-chartjs";
export default {
  name: "graphic",
  components: {
    Bar
  },
  props: {
    configurations: Object
  },
  data: function() {
    return {
      mychar: Object
    };
  },
  updated() {
    if (functionHelpers.isValued(this.myChart)) {
      this.myChart.destroy();
    }
    var configurations = this.configurations;
    var planetChartData = configurations.confGrafic;
    this.createChartComp(configurations.idCont, planetChartData);
  },
  mounted() {
    var configurations = this.configurations;
    var planetChartData = configurations.confGrafic;
    this.createChartComp(configurations.idCont, planetChartData);
  },
  methods: {
    createChartComp(chartIdComp, chartDataComp) {
      var ctx = document.getElementById(chartIdComp);
      if (chartDataComp != null) {
        this.myChart = new Chart(ctx, {
          type: chartDataComp.type,
          data: chartDataComp.data,
          options: chartDataComp.options
        });
      }
    }
  }
};
</script>
